import { memo } from "react";
import { Box, Typography } from "@mui/material";
import theme from "themeProvider";
import { EVENT_CATEGORIES } from "../../eventIconMap";

const Legend = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: 3,
      marginTop: 10,
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      py: 2,
    }}
  >
    {EVENT_CATEGORIES.map(({ label, color }) => (
      <Box key={label} display="flex" alignItems="center" gap={0.75}>
        <Box
          sx={{
            width: 9,
            height: 9,
            borderRadius: "50%",
            background: color,
            flexShrink: 0,
          }}
        />
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.3,
            color: theme.palette.text.secondary,
          }}
        >
          {label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default memo(Legend);
